"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeadingAliases = void 0;
var paragraphs_1 = require("../paragraphs");
var getHeadingAliases = function (globals, brand) {
    return {
        color: (0, paragraphs_1.getTypographyColor)(globals, brand),
        fontFamily: globals.fonts.primary.bold,
    };
};
exports.getHeadingAliases = getHeadingAliases;
